// Phoenix's own contact details for the public funnel footer.
//
// GET /prequalification/phoenix-contact is anonymous and returns exactly three
// fields, projected from the Brand Identity singleton. It is the ONLY public read of
// that record — everything else on it (the address, the internal legal footer, the
// brand-voice description, the blob paths) stays server-side, and a C# shape test
// pins the projection so a column added upstream cannot leak here.
//
// NATIVE funnel only. A partner-branded funnel shows the PARTNER's contact details
// or none at all — it never falls back to these, because a Phoenix address on a
// white-labelled page defeats the white label. The footer picks its source from the
// branch it is already in; there is no cross-brand merge.

import { portalApi } from "./client";

/** Every field is nullable and may be blank — the footer suppresses an empty
 *  element entirely rather than rendering a bare link or an orphaned separator. */
export interface PhoenixContact {
  website: string | null;
  email: string | null;
  phone: string | null;
}

/**
 * Resolve Phoenix's funnel contact details.
 *
 * **Returns `null` on ANY failure, and never throws** — the `fetchPrequalFunnelCopy`
 * posture, for the same reason. There is nothing to tell the visitor and nothing for
 * them to do; a 429, an outage or a parse failure degrades to a footer with no
 * contact line, which is the state the page is already designed to render when a
 * value is unset.
 */
export async function fetchPhoenixContact(): Promise<PhoenixContact | null> {
  try {
    return await portalApi.get<PhoenixContact>("/prequalification/phoenix-contact");
  } catch {
    return null;
  }
}
